module.exports = __webpack_public_path__ + "static/img/industries9.bfd7167.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/industries9.png
// module id = +epm
// module chunks = 1